import { render } from "./PatientCreateTab.vue?vue&type=template&id=428049d8"
import script from "./PatientCreateTab.vue?vue&type=script&lang=js"
export * from "./PatientCreateTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__